import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Link } from 'react-router-dom'
import { List, Breadcrumb } from 'antd'
import { slugify } from '../libs/utils.js'
import _ from 'underscore'

@observer
class Documents extends Component {
  
  componentDidMount(){
    window.scrollTo(0, 0)
  }
  
  render(){
  
    var { params } = this.props.match
    var { store } = this.props

    var depth = 0
    
    if(params.folder1)
      depth++
      
    if(params.folder2)
      depth++
    
    var navs = store.nav.get_list

    if(!navs || navs.length === 0)
      return 'Loading'
    
    var documents = []
    var folder = {}
    var sub_folder = {}
    
    if(depth > 0){
      folder = _.where(navs, { lower: params.folder1.replace(/-/g, ' ') })[0]
      if(!folder || !folder.children)
        return 'Documents not found'
      documents = folder.children
    }

    if(depth > 1){
      sub_folder = _.where(folder.children, { lower: params.folder2.replace(/-/g, ' ') })[0]
      if(!sub_folder || !sub_folder.id)
        return 'Documents not found'
      documents = [sub_folder]
    }

    // console.log("folder name:", folder.name)
    // console.log('folder', folder)
    // console.log('sub_folder', sub_folder)
    // console.log('documents', documents)
    
    return (
      <div>
        
        <Breadcrumb separator="&rarr;">
          {depth > 0 ? <Breadcrumb.Item><a href="/">Home</a></Breadcrumb.Item> : ''}
          {depth > 0 ? <Breadcrumb.Item><a href={"/"+slugify(folder.name)}>{folder.name}</a></Breadcrumb.Item> : ''}
          {depth > 1 ? <Breadcrumb.Item className="spot1">{sub_folder.name}</Breadcrumb.Item> : ''}
        </Breadcrumb>
        
        <br /><br />
        
        {documents.map((doc, key) => {

          return (
            <List
              key={key}
              itemLayout="horizontal"
              header={<div className="sectionHeader spot1">{doc.title || doc.name}</div>}
              dataSource={doc.documents}
              bordered={true}
              style={{marginBottom: 45}}
              renderItem={item => {
                
                // console.log('item', item)

                var title = item.title || item.name

                var slug = slugify(title)

                return (
                  <List.Item>
                    <List.Item.Meta
                      title={<Link to={"/doc/"+item.id+"/"+slug}>{title}</Link>}
                    />
                  </List.Item>
                )
                
              }}
            />
          )
        })}
        
      </div>
    )
    
  }
  
}

export default Documents


// WEBPACK FOOTER //
// ./src/components/Documents.js